import { useEffect, useState } from 'react';
import { APP_IMAGES, AppConfig } from '../constants';
import { useIsMobileView } from './useIsMobileView';

export const useAppImages = () => {
  const isMobile = useIsMobileView();
  const [spinner, setSpinnerSrc] = useState('');
  const [logo, setLogoSrc] = useState('');
  const [splashLogo, setSplashLogoSrc] = useState('');
  const [card, setCardSrc] = useState('');
  const [background, setBackgroundSrc] = useState('');

  useEffect(() => {
    const background = isMobile ? APP_IMAGES.bannerXs : APP_IMAGES.bannerLg;
    const card = isMobile ? APP_IMAGES.cardXs : APP_IMAGES.cardLg;
    const logo = APP_IMAGES.logo;
    const spinner = APP_IMAGES.spinner;
    const splashLogo = APP_IMAGES.splashLogo;
    setBackgroundSrc(
      `${AppConfig.CDN_BASE_URL}/${AppConfig.PARTNER}/${AppConfig.DEFAULT_MERCHANT_NAME}/${background}.png`,
    );
    setCardSrc(`${AppConfig.CDN_BASE_URL}/${AppConfig.PARTNER}/${AppConfig.DEFAULT_MERCHANT_NAME}/${card}.png`);
    setLogoSrc(
      `${AppConfig.CDN_BASE_URL}/${AppConfig.PARTNER}/${AppConfig.DEFAULT_MERCHANT_NAME}/${AppConfig.LOGO_IMAGE_NAME}`,
    );
    setSplashLogoSrc(
      `${AppConfig.CDN_BASE_URL}/${AppConfig.PARTNER}/${AppConfig.DEFAULT_MERCHANT_NAME}/${AppConfig.SPLASH_LOGO_IMAGE_NAME}`,
    );
    setSpinnerSrc(`${AppConfig.CDN_BASE_URL}/${AppConfig.PARTNER}/${AppConfig.DEFAULT_MERCHANT_NAME}/${spinner}.gif`);
  }, [isMobile]);

  return { logo, background, card, spinner, splashLogo };
};
